import type {
  ApiContractType,
  ApiCustomField,
  ApiCustomFieldRequest,
  ApiEnumGroup,
  ApiFunction,
  ApiItemType,
  ApiUnit,
  GenericHttpResult,
} from '@agunity/api-v4';

import { apiService } from '../../api/apiService';

export const getCustomFieldsList = (data: ApiCustomFieldRequest) => {
  return async (): Promise<GenericHttpResult<ApiCustomField[]>> => {
    const response = await apiService.customFieldV11ListCreate(data);
    return response;
  };
};

export const getCustomFieldDetails = (id: number) => {
  return async (): Promise<GenericHttpResult<ApiCustomField>> => {
    const response = await apiService.customFieldV10ItemDetail(id);
    return response;
  };
};

export const postCustomField = (data: ApiCustomField) => {
  return async (): Promise<GenericHttpResult<number>> => {
    const response = await apiService.customFieldV10ItemCreate(data);
    return response;
  };
};

export const patchCustomField = (id: number, data: ApiCustomField) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.customFieldV10ItemPartialUpdate(id, data);
    return response;
  };
};

export const deleteCustomField = (id: number) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.customFieldV10ItemDelete(id);
    return response;
  };
};

export const getItemTypesList = () => {
  return async (): Promise<GenericHttpResult<ApiItemType[]>> => {
    const response = await apiService.systemV10ItemTypesList();
    return response;
  };
};

export const getUnitList = () => {
  return async (): Promise<GenericHttpResult<ApiUnit[]>> => {
    const response = await apiService.systemV10UnitsList();
    return response;
  };
};

export const getFunctionList = () => {
  return async (): Promise<GenericHttpResult<ApiFunction[]>> => {
    const response = await apiService.functionV20ListList();
    return response;
  };
};

export const getEnumList = () => {
  return async (): Promise<GenericHttpResult<ApiEnumGroup[]>> => {
    const response = await apiService.enumV10ListList();
    return response;
  };
};

export const getContractTypesList = () => {
  return async (): Promise<GenericHttpResult<ApiContractType[]>> => {
    const response = await apiService.contractV10TypeListList();
    return response;
  };
};
